import React from 'react';
import { Navbar, Nav, Button, Container } from 'react-bootstrap';
import './Navbar.css'; // Custom styles if needed
import hotel_icon from '../assets/hotel_icon.webp';

const CustomNavbar = () => {
  return (
    <Navbar expand="lg" bg="light" variant="light" fixed="top" className="navbar">
      <Container>
        <Navbar.Brand href="#">
          <img
            src={hotel_icon}
            alt="Hotel Icon"
            height="40"
            draggable="false"
            className="me-2" // Adds space between the icon and the text
          />
          Hotel Czyżew
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarContent" />
        <Navbar.Collapse id="navbarContent">
          <Nav className="ms-auto align-items-center">
            <Nav.Link href="#about" className="mx-2">
              <i className="fas fa-plus-circle pe-2"></i>O nas
            </Nav.Link>
            <Nav.Link href="#gallery" className="mx-2" offsite = {-700}>
              <i className="fas fa-bell pe-2"></i>Galeria
            </Nav.Link>
            <Nav.Link href="#map" className="mx-2">
              <i className="fas fa-heart pe-2"></i>Znajdź nas
            </Nav.Link>
            <Nav.Link href="#contact" className="mx-2">
              <i className="fas fa-plus-circle pe-2"></i>Kontakt
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
